module.exports = __webpack_public_path__ + "static/img/vertical_orange_sm.45863a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vertical_orange_sm.svg
// module id = HFK1
// module chunks = 1